import { dashboardService } from "@/api/services/dashboardService";
import { DashboardApiMetricWidget } from "../dashboardLeafWidgets";

type Data = Record<string, any>;

/** 会员用户统计，保留各会员类型和总量字段。 */
export default function MemberCustomerStatistic() {
    return (
        <DashboardApiMetricWidget<Data>
            title="会员用户统计"
            load={value => dashboardService.getMemberCustomerStatistic(value as never)}
            metrics={[
                { label: "基础会员", key: "baseMemberNum", unit: "人" },
                { label: "高级会员", key: "seniorMemberNum", unit: "人" },
                { label: "企业会员", key: "enterpriseGradeMemberNum", unit: "人" }
            ]}
        />
    );
}
